import camelCase from 'lodash.camelcase';

export function camelizeKeys(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map((v) => camelizeKeys(v));
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key).toString()]: camelizeKeys(obj[key]),
      }),
      {}
    );
  }

  return obj;
}
